import { Trace } from '@sensenet/client-utils';
import React, { createContext, useEffect, useState } from 'react';
import { useDocumentData, useDocumentViewerApi, useViewerState } from "../hooks/index.js";
export const defaultCommentsContext = {
  comments: [],
  addPreviewComment: async () => undefined,
  deletePreviewComment: async () => undefined,
  getPreviewComments: async () => undefined
};
export const CommentsContext = /*#__PURE__*/createContext(defaultCommentsContext);
export const CommentsContextProvider = props => {
  const api = useDocumentViewerApi();
  const {
    documentData
  } = useDocumentData();
  const viewerState = useViewerState();
  const [comments, setComments] = useState([]);
  useEffect(() => {
    const abortController = new AbortController();
    (async () => {
      if (viewerState.showComments) {
        const result = await api.commentActions.getPreviewComments({
          document: documentData,
          page: viewerState.activePage,
          abortController
        });
        setComments(result);
      }
    })();
    return () => abortController.abort();
  }, [api.commentActions, documentData, viewerState.activePage, viewerState.showComments]);
  useEffect(() => {
    const disposables = [Trace.method({
      object: api.commentActions,
      isAsync: true,
      methodName: 'addPreviewComment',
      method: api.commentActions.addPreviewComment,
      onFinished: async ({
        returned
      }) => {
        const a = await returned;
        setComments([...comments, a]);
        viewerState.updateState({
          isPlacingCommentMarker: false
        });
      }
    }), Trace.method({
      object: api.commentActions,
      method: api.commentActions.deletePreviewComment,
      methodName: 'deletePreviewComment',
      isAsync: true,
      onFinished: async ({
        returned,
        methodArguments
      }) => {
        const returnedValue = await returned;
        if (returnedValue.modified) {
          setComments(comments.filter(c => c.id !== methodArguments[0].commentId));
        }
      }
    })];
    return () => disposables.forEach(d => d.dispose());
  }, [api.commentActions, comments, viewerState]);
  return /*#__PURE__*/React.createElement(CommentsContext.Provider, {
    value: {
      ...api.commentActions,
      comments
    }
  }, props.children);
};
//# sourceMappingURL=comments.js.map